import { createMarkerIcon, MAP_STYLES } from './google-map-styles';

const DEFAULT_ZOOM = 14;

function parseCanvasData(canvas) {
  const lat = parseFloat(canvas.getAttribute('data-lat'));
  const lng = parseFloat(canvas.getAttribute('data-lng'));
  const address = (canvas.getAttribute('data-address') || '').trim();
  const zoom = parseInt(canvas.getAttribute('data-zoom'), 10);

  return {
    lat: Number.isFinite(lat) ? lat : null,
    lng: Number.isFinite(lng) ? lng : null,
    address,
    zoom: Number.isFinite(zoom) && zoom > 0 ? zoom : DEFAULT_ZOOM,
  };
}

function resolvePosition(data) {
  if (data.lat !== null && data.lng !== null) {
    return Promise.resolve({ lat: data.lat, lng: data.lng });
  }

  if (!data.address) {
    return Promise.resolve(null);
  }

  return new Promise((resolve) => {
    const geocoder = new google.maps.Geocoder();

    geocoder.geocode({ address: data.address }, (results, status) => {
      if (status !== 'OK' || !results || !results[0]) {
        resolve(null);
        return;
      }

      const location = results[0].geometry.location;

      resolve({
        lat: location.lat(),
        lng: location.lng(),
      });
    });
  });
}

function initCanvas(canvas) {
  if (typeof google === 'undefined' || !google.maps) {
    return;
  }

  const data = parseCanvasData(canvas);

  resolvePosition(data).then((position) => {
    if (!position) {
      return;
    }

    const map = new google.maps.Map(canvas, {
      center: position,
      zoom: data.zoom,
      styles: MAP_STYLES,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      zoomControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_CENTER,
      },
    });

    new google.maps.Marker({
      map,
      position,
      title: data.address,
      icon: createMarkerIcon(),
    });

    google.maps.event.addListenerOnce(map, 'idle', () => {
      google.maps.event.trigger(map, 'resize');
      map.setCenter(position);
    });
  });
}

export default function initDepotSingleMaps() {
  document.querySelectorAll('.depot-single-map-canvas').forEach((canvas) => {
    initCanvas(canvas);
  });
}
